/**
 * Add-to-cart form interceptor.
 *
 * Intercepts submissions of any form with class .main-product__form (the
 * class set by sections/main-product.liquid via {% form 'product', ...,
 * class: 'main-product__form' %}). Targeting by class rather than a data
 * attribute because Shopify's {% form %} tag doesn't accept arbitrary HTML
 * attributes — it reads extra kwargs positionally as form types.
 *
 * Posts the form data to the form's own action URL (Shopify's /cart/add)
 * with Accept: application/json, then dispatches a `cart:added` event the
 * <cart-drawer> component listens for. If anything fails, falls through to
 * the form's native submit so the user still gets to /cart.
 */

document.addEventListener('submit', (e) => {
  const form = e.target.closest('.main-product__form');
  if (!form) return;
  // If a previous attempt errored and asked for a native submit, let it through.
  if (form.dataset.cartFallback === 'true') return;

  e.preventDefault();

  const submit = form.querySelector('[type="submit"]');
  if (submit) submit.disabled = true;

  fetch(form.action, {
    method: 'POST',
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: new FormData(form),
  })
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw err;
        });
      }
      return res.json();
    })
    .then((item) => {
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { item } }));
    })
    .catch((err) => {
      console.error('Add to cart failed:', err);
      // Fall back to native submission on the next attempt so the user still
      // gets to /cart even if the AJAX layer is broken (e.g., 422 inventory).
      form.dataset.cartFallback = 'true';
    })
    .finally(() => {
      if (submit) submit.disabled = false;
    });
});
